import {
  DocumentNode,
  LazyQueryResultTuple,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useLazyQuery as useApolloLazyQuery,
} from '@apollo/client';
import { useToast } from '../providers/ToastProvider';
import { ToastType } from '../ui/components/Toast';

export default function useLazyQuery<TData = any, TVariables = OperationVariables>(
  mutation: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<TData, TVariables>,
): LazyQueryResultTuple<TData, TVariables> {
  const { showToast } = useToast();

  return useApolloLazyQuery<TData, TVariables>(mutation, {
    ...options,
    onError: error => {
      console.error(error);
      if (options?.onError) return options.onError(error);

      const message = error.message;
      if (message.length > 75) {
        showToast({ type: ToastType.error, title: 'An error has occurred!', content: message });
      } else {
        showToast({ type: ToastType.error, title: message });
      }
    },
  });
}
